'use strict';

class Dimension {
    constructor(tilesSmall, tilesLarge) {
        this.tilesSmall = tilesSmall;
        this.tilesLarge = tilesLarge;
    }
    getNumberOfTiles(width) {return width < 700 ? this.tilesSmall : this.tilesLarge}
}

const CINEMAMODE = {
    PORTRAIT: new Dimension(2, 4),
    LANDSCAPE: new Dimension(1, 3),
    SQUARE: new Dimension(2, 5),
    MIXED: new Dimension(2, 4),
    REDESIGN: {},
    UNKNOWN: {},
};
const getCinemaModeByName = (name) => CINEMAMODE[name] ?? CINEMAMODE.UNKNOWN
export {CINEMAMODE, getCinemaModeByName}